import classNames from 'classnames';

import { InvisibleAnchorProps } from '~components/InvisibleAnchor/types';
import { useHeaderVisibility } from '~hooks/useHeaderVisibility';

import styles from './InvisibleAnchor.module.scss';

export function InvisibleAnchor({
  id,
  elRef,
  className,
}: InvisibleAnchorProps) {
  const { headerVisible } = useHeaderVisibility();

  const anchor = id.toString().replace(/[#\s]/g, '');

  return (
    <div
      id={anchor}
      ref={elRef}
      className={classNames(
        styles.anchor,
        headerVisible && styles.headerUp,
        className,
      )}
    />
  );
}
